import { useEffect, useRef } from 'react';
import { isFirefox } from 'react-device-detect';

/**
 * Firefox autofill does not trigger any event handler when autopopulating a field on page load. This makes it impossible to detect via conventional means.
 *
 * This hook checks for autofill by polling the field value on an interval {@link autofillCheckLimit} amount of times.
 */
export function useFirefoxAutofillHandling(
  reactFieldValue: string,
  changeFieldValue: (value: string) => void,
  autofillCheckLimit: number = 5
) {
  const fieldRef = useRef<HTMLInputElement | null>(null);
  const firefoxAutofillCheckCount = useRef(0);
  const autofillDetectedRef = useRef(false);

  useEffect(() => {
    if (
      fieldRef.current &&
      !autofillDetectedRef.current &&
      fieldRef.current.value !== reactFieldValue &&
      firefoxAutofillCheckCount.current < autofillCheckLimit &&
      isFirefox
    ) {
      const interval = setInterval(() => {
        firefoxAutofillCheckCount.current++;
        if (fieldRef.current && fieldRef.current.value !== reactFieldValue) {
          changeFieldValue(fieldRef.current.value);
          autofillDetectedRef.current = true;
        }
      }, 100);
      return () => clearInterval(interval);
    }
  }, [changeFieldValue, reactFieldValue, autofillCheckLimit]);

  return { fieldRef };
}
